import { Divider, Typography } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import Background from 'ui/atoms/Background/Background';
import Title from 'ui/atoms/Title/Title';

const TitleWrapper = styled.div`
  position: absolute;
  top: 4rem;
  left: 8rem;
`;

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100vw - 16rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 3rem 5rem;
  background-color: ${({ theme }) => theme.colors.bgLight};
`;

const WaitingForPermissions: React.FC<React.PropsWithChildren> = () => (
  <>
    <Background id="background" />
    <TitleWrapper>
      <Title />
    </TitleWrapper>
    <Wrapper>
      <Typography variant="h4">Waiting for permissions</Typography>
      <Divider />
      <Typography variant="body1">
        Please hold on while ATLAS completes the setup process. Once the necessary permissions are configured,
        you&apos;ll be automatically redirected to the next page.
      </Typography>
      <Divider />
    </Wrapper>
  </>
);
export default WaitingForPermissions;
